<div class="dialog-loading" *ngIf="(loading$ | async)">
    <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
    <div class="dialog-title">{{'modules.clients.associations.associationManagerDialog.title' | translate}}</div>
    <div class="dialog-close" (click)="closeDialog(false)">
        <mat-icon>close</mat-icon>
    </div>
</div>
<div class="dialog-content scrollable">
    <form [formGroup]="managerForm" class="dialog-form scroll-content-padding df-c gap15" autocomplete="off" >
        <div class="df gap20">

            <autocomplete-item-field class="grow"
                                     [dataType]="'MANAGER'"
                                     label="{{'modules.clients.associations.associationViewDialog.tables.managers.manager' | translate}}"
                                     formControlName="manager">
            </autocomplete-item-field>

            <mat-form-field appearance="outline" floatLabel="always" class="no-padding grow">
                <mat-label>{{'modules.clients.associations.associationViewDialog.tables.managers.role' | translate}}</mat-label>
                <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" formControlName="position">
                    <mat-option *ngFor="let role of roles" [value]="role">{{'modules.references.administrators.positions.' + role | translate}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
</div>

<div class="buttons-row df jc-e ai-c">
    <button class="default-button apply-button" [disabled]="managerForm.invalid" (click)="submitForm()">
        {{'common.save' | translate}}
    </button>
</div>
